import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'
import { CSStackParamList } from './CSStackParamList'
import { CSScreen } from './CSScreen'
import { pipe } from 'fp-ts/lib/function'
import { ErrorHandling, Permission, RBAC } from '@pulseops/common'
import { CSStackContext } from './CSStackContext'
import { CSGADDocument } from './cs-gad-document'
import { CSProcessGuidelineDoc } from './cs-process-guideline-document'
import { CSInventoryReportDoc } from './cs-inventory-report-document'
import { CSInternalProcessGuidelineDoc } from './cs-internal-process-guideline-document'
const stack = createStackNavigator<CSStackParamList>()
export const CSStack = () => {
  const permissions: string[] = pipe(RBAC.permissionWithNoCache, ErrorHandling.runDidMount([]))
  return (
    <CSStackContext.Provider value={{ userPermissions: permissions }}>
      <stack.Navigator initialRouteName="CSScreen" screenOptions={{ headerShown: false }}>
        <stack.Screen name="CSScreen" component={CSScreen} />
        {permissions.includes(Permission.LinkGADDocsCSDocsManage) && (
          <stack.Screen name="CSGADDocument" component={CSGADDocument} />
        )}
        {permissions.includes(Permission.LinkProcessGuidelinesCSDocsManage) && (
          <stack.Screen name="CSProcessGuidelineDoc" component={CSProcessGuidelineDoc} />
        )}
        {permissions.includes(Permission.LinkInventoryReportCSDocsManage) && (
          <stack.Screen name="CSInventoryReportDoc" component={CSInventoryReportDoc} />
        )}
        {permissions.includes(Permission.LinkInternalProcessGuideCSDocsManage) && (
          <stack.Screen name="CSInternalProcessGuidelineDoc" component={CSInternalProcessGuidelineDoc} />
        )}
      </stack.Navigator>
    </CSStackContext.Provider>
  )
}
